// Mock data for testing frontend without backend

export const mockUsers = {
  admin: {
    id: 1,
    username: 'admin',
    email: 'admin@ouk.ac.ke',
    role: 'admin',
    mustChangePassword: false
  },
  recruiter: {
    id: 2,
    username: 'john',
    email: 'john@example.com',
    role: 'recruiter',
    mustChangePassword: false
  },
  financial_officer: {
    id: 3,
    username: 'finance',
    email: 'finance@ouk.ac.ke',
    role: 'financial_officer',
    mustChangePassword: false
  }
};

export const mockRecruiters = [
  {
    id: 1,
    user_id: 2,
    username: 'john',
    email: 'john@example.com',
    referral_code: 'OUK12345678',
    full_name: 'John Doe',
    nationality: 'Kenyan',
    id_passport: '12345678',
    kra_pin: 'A001234567P',
    county: 'Nairobi',
    subcounty: 'Westlands',
    location: 'Parklands',
    sublocation: 'Highridge',
    village: 'Westlands Estate',
    mobile_number: '+254712345678',
    residential_address: '123 Parklands Road',
    postal_address: 'P.O. Box 12345 Nairobi',
    bank_account: '1234567890',
    mobile_money_number: '+254712345678',
    status: 'active',
    is_active: true
  },
  {
    id: 2,
    user_id: 3,
    username: 'jane',
    email: 'jane@example.com',
    referral_code: 'OUK87654321',
    full_name: 'Jane Smith',
    nationality: 'Kenyan',
    id_passport: '87654321',
    kra_pin: 'A007654321P',
    county: 'Mombasa',
    subcounty: 'Mvita',
    location: 'Mombasa Island',
    sublocation: 'Tudor',
    village: 'Tudor Estate',
    mobile_number: '+254723456789',
    residential_address: '456 Moi Avenue',
    postal_address: 'P.O. Box 54321 Mombasa',
    bank_account: '0987654321',
    mobile_money_number: '+254723456789',
    status: 'active',
    is_active: true
  },
  {
    id: 3,
    user_id: 4,
    username: 'peter',
    email: 'peter@example.com',
    referral_code: 'OUK11223344',
    full_name: 'Peter Kamau',
    nationality: 'Kenyan',
    id_passport: '11223344',
    kra_pin: 'A001122334P',
    county: 'Kisumu',
    subcounty: 'Kisumu East',
    location: 'Migosi',
    sublocation: 'Nyalenda',
    village: 'Migosi Estate',
    mobile_number: '+254734567890',
    residential_address: '789 Oginga Odinga Road',
    postal_address: 'P.O. Box 67890 Kisumu',
    bank_account: '1122334455',
    mobile_money_number: '+254734567890',
    status: 'active',
    is_active: true
  }
];

export const mockDashboardStats = {
  overview: {
    activeRecruiters: 25,
    totalAdmissions: 150,
    totalEnrollments: 120,
    totalCommissions: 111000, // (150 * 500) + (120 * 300) = 75,000 + 36,000 = 111,000
    pendingPayments: 5,
    pendingAmount: 12500
  },
  topRecruiters: [
    {
      id: 1,
      full_name: 'John Doe',
      referral_code: 'OUK12345678',
      admission_count: 15,
      enrollment_count: 12,
      total_commission: 11100 // (15 * 500) + (12 * 300) = 7,500 + 3,600 = 11,100
    },
    {
      id: 2,
      full_name: 'Jane Smith',
      referral_code: 'OUK87654321',
      admission_count: 12,
      enrollment_count: 10,
      total_commission: 9000 // (12 * 500) + (10 * 300) = 6,000 + 3,000 = 9,000
    },
    {
      id: 3,
      full_name: 'Peter Kamau',
      referral_code: 'OUK11223344',
      admission_count: 10,
      enrollment_count: 8,
      total_commission: 7400 // (10 * 500) + (8 * 300) = 5,000 + 2,400 = 7,400
    }
  ],
  monthlySummary: [
    { month: '2024-03', admissions: 25, enrollments: 20, total_commission: 18500 }, // (25*500) + (20*300)
    { month: '2024-02', admissions: 30, enrollments: 25, total_commission: 22500 }, // (30*500) + (25*300)
    { month: '2024-01', admissions: 28, enrollments: 22, total_commission: 20600 }, // (28*500) + (22*300)
    { month: '2023-12', admissions: 22, enrollments: 18, total_commission: 16400 }, // (22*500) + (18*300)
    { month: '2023-11', admissions: 20, enrollments: 16, total_commission: 14800 }, // (20*500) + (16*300)
    { month: '2023-10', admissions: 25, enrollments: 20, total_commission: 18500 }  // (25*500) + (20*300)
  ]
};

export const mockPayments = [
  {
    id: 1,
    recruiter_id: 1,
    full_name: 'John Doe',
    referral_code: 'OUK12345678',
    total_admissions: 15,
    total_enrollments: 12,
    cumulative_amount: 11100, // (15 * 500) + (12 * 300) = 7,500 + 3,600 = 11,100
    payment_status: 'paid',
    payment_date: '2024-03-01',
    mobile_money_number: '+254712345678',
    bank_account: '1234567890'
  },
  {
    id: 2,
    recruiter_id: 2,
    full_name: 'Jane Smith',
    referral_code: 'OUK87654321',
    total_admissions: 12,
    total_enrollments: 10,
    cumulative_amount: 9000, // (12 * 500) + (10 * 300) = 6,000 + 3,000 = 9,000
    payment_status: 'pending',
    payment_date: null,
    mobile_money_number: '+254723456789',
    bank_account: '0987654321'
  }
];

export const mockAuditLogs = [
  {
    id: 1,
    user_id: 1,
    username: 'admin',
    email: 'admin@ouk.ac.ke',
    action: 'login',
    resource: 'auth',
    resource_id: null,
    details: 'Successful login',
    ip_address: '192.168.1.1',
    created_at: '2024-03-17T10:30:00Z'
  },
  {
    id: 2,
    user_id: 1,
    username: 'admin',
    email: 'admin@ouk.ac.ke',
    action: 'create_recruiter',
    resource: 'recruiters',
    resource_id: 1,
    details: 'Created recruiter: John Doe',
    ip_address: '192.168.1.1',
    created_at: '2024-03-17T11:00:00Z'
  },
  {
    id: 3,
    user_id: 2,
    username: 'john',
    email: 'john@example.com',
    action: 'login',
    resource: 'auth',
    resource_id: null,
    details: 'Successful login',
    ip_address: '192.168.1.5',
    created_at: '2024-03-17T12:00:00Z'
  }
];

export const mockStudents = {
  admissions: [
    {
      type: 'admission',
      student_id: 'STU001',
      date: '2024-01-15',
      verified: true,
      commission_amount: 500 // KES 500 for admission
    },
    {
      type: 'admission',
      student_id: 'STU002',
      date: '2024-01-20',
      verified: true,
      commission_amount: 500 // KES 500 for admission
    },
    {
      type: 'admission',
      student_id: 'STU003',
      date: '2024-02-05',
      verified: false,
      commission_amount: 500 // KES 500 for admission
    }
  ],
  enrollments: [
    {
      type: 'enrollment',
      student_id: 'STU001',
      date: '2024-02-01',
      verified: true,
      commission_amount: 300 // KES 300 for session registration
    },
    {
      type: 'enrollment',
      student_id: 'STU002',
      date: '2024-02-10',
      verified: true,
      commission_amount: 300 // KES 300 for session registration
    }
  ],
  total: 5
};

export const mockCommissions = {
  admissions: {
    count: 15,
    total: 7500 // 15 * 500 = 7,500
  },
  enrollments: {
    count: 12,
    total: 3600 // 12 * 300 = 3,600
  },
  cumulativeTotal: 11100, // 7,500 + 3,600 = 11,100
  payments: [
    {
      id: 1,
      total_admissions: 10,
      total_enrollments: 8,
      cumulative_amount: 7400, // (10 * 500) + (8 * 300) = 5,000 + 2,400 = 7,400
      payment_status: 'paid',
      payment_date: '2024-03-01'
    },
    {
      id: 2,
      total_admissions: 5,
      total_enrollments: 4,
      cumulative_amount: 3700, // (5 * 500) + (4 * 300) = 2,500 + 1,200 = 3,700
      payment_status: 'pending',
      payment_date: null
    }
  ]
};

export const mockRecruiterProfile = {
  id: 1,
  user_id: 2,
  username: 'john',
  email: 'john@example.com',
  referral_code: 'OUK12345678',
  full_name: 'John Doe',
  nationality: 'Kenyan',
  id_passport: '12345678',
  kra_pin: 'A001234567P',
  county: 'Nairobi',
  subcounty: 'Westlands',
  location: 'Parklands',
  sublocation: 'Highridge',
  village: 'Westlands Estate',
  mobile_number: '+254712345678',
  residential_address: '123 Parklands Road',
  postal_address: 'P.O. Box 12345 Nairobi',
  bank_account: '1234567890',
  mobile_money_number: '+254712345678',
  status: 'active'
};

export const mockNotifications = [
  {
    id: 1,
    recruiter_id: 1,
    type: 'admission',
    title: 'New student admission confirmed',
    message: 'Student STU003 successfully admitted to Business Administration program',
    data: { student_id: 'STU003', program: 'Business Administration', commission: 500 },
    is_read: false,
    created_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString() // 2 hours ago
  },
  {
    id: 2,
    recruiter_id: 1,
    type: 'enrollment',
    title: 'Student enrollment completed',
    message: 'Student STU002 enrolled and started classes - commission earned!',
    data: { student_id: 'STU002', program: 'Computer Science', commission: 300 },
    is_read: false,
    created_at: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString() // 1 day ago
  },
  {
    id: 3,
    recruiter_id: 1,
    type: 'payment',
    title: 'Commission payment received',
    message: 'KES 8,000 commission credited to your M-Pesa account',
    data: { amount: 8000, method: 'M-Pesa', reference: 'TXN001234' },
    is_read: true,
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString() // 3 days ago
  },
  {
    id: 4,
    recruiter_id: 1,
    type: 'achievement',
    title: 'Achievement unlocked',
    message: 'Congratulations! You\'ve reached 15 successful admissions this month',
    data: { milestone: 15, type: 'admissions', period: 'monthly' },
    is_read: true,
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString() // 1 week ago
  },
  {
    id: 5,
    recruiter_id: 1,
    type: 'admission',
    title: 'Student admission pending verification',
    message: 'Student STU004 admission is under review by the admissions office',
    data: { student_id: 'STU004', program: 'Engineering', status: 'pending' },
    is_read: true,
    created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 6,
    recruiter_id: 1,
    type: 'system',
    title: 'Profile update required',
    message: 'Please update your payment information to ensure timely commission payments',
    data: { action_required: 'update_payment_info' },
    is_read: true,
    created_at: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString() // 2 weeks ago
  },
  {
    id: 7,
    recruiter_id: 1,
    type: 'enrollment',
    title: 'Multiple enrollments processed',
    message: '3 students you recruited have completed their enrollment process',
    data: { count: 3, total_commission: 900 },
    is_read: true,
    created_at: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString() // 3 weeks ago
  },
  {
    id: 8,
    recruiter_id: 1,
    type: 'payment',
    title: 'Monthly commission statement',
    message: 'Your February commission statement is now available for download',
    data: { period: 'February 2024', total: 15000, status: 'available' },
    is_read: true,
    created_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString() // 1 month ago
  },
  {
    id: 9,
    recruiter_id: 1,
    type: 'achievement',
    title: 'Top performer recognition',
    message: 'You\'re in the top 10% of recruiters this quarter! Keep up the excellent work',
    data: { rank: 'top_10_percent', period: 'Q1 2024' },
    is_read: true,
    created_at: new Date(Date.now() - 35 * 24 * 60 * 60 * 1000).toISOString() // 5 weeks ago
  },
  {
    id: 10,
    recruiter_id: 1,
    type: 'system',
    title: 'System maintenance notification',
    message: 'The recruiter portal will undergo maintenance on March 15th from 2:00 AM to 4:00 AM',
    data: { maintenance_date: '2024-03-15', start_time: '02:00', end_time: '04:00' },
    is_read: true,
    created_at: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString() // 6+ weeks ago
  }
];

export const mockAdminNotifications = [
  {
    id: 11,
    admin_id: 1,
    type: 'recruiter_registration',
    title: 'New recruiter registered',
    message: 'John Doe from Nairobi has successfully registered with referral code OUK12345',
    data: { recruiter_name: 'John Doe', referral_code: 'OUK12345', location: 'Nairobi' },
    is_read: false,
    created_at: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString() // 1 hour ago
  },
  {
    id: 12,
    admin_id: 1,
    type: 'payment_processed',
    title: 'Bulk payment processing completed',
    message: 'KES 245,000 in commissions paid to 15 recruiters via M-Pesa and bank transfers',
    data: { total_amount: 245000, recruiter_count: 15, payment_methods: ['M-Pesa', 'Bank Transfer'] },
    is_read: false,
    created_at: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString() // 3 hours ago
  },
  {
    id: 13,
    admin_id: 1,
    type: 'system_alert',
    title: 'High admission volume detected',
    message: 'Record 45 admissions processed today - 28% above monthly average',
    data: { admission_count: 45, percentage_increase: 28, period: 'daily' },
    is_read: false,
    created_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString() // 6 hours ago
  },
  {
    id: 14,
    admin_id: 1,
    type: 'bulk_upload',
    title: 'Bulk recruiter upload completed',
    message: 'CSV upload processed: 12 recruiters added successfully, 3 validation errors',
    data: { success_count: 12, error_count: 3, filename: 'recruiters_batch_march.csv' },
    is_read: true,
    created_at: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString() // 1 day ago
  },
  {
    id: 15,
    admin_id: 1,
    type: 'performance_milestone',
    title: 'Monthly performance milestone reached',
    message: 'System has processed 500+ admissions this month - new record!',
    data: { milestone: 500, type: 'admissions', period: 'monthly', previous_record: 425 },
    is_read: true,
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString() // 2 days ago
  },
  {
    id: 16,
    admin_id: 1,
    type: 'recruiter_performance',
    title: 'Top recruiter achievement',
    message: 'Jane Smith has become the first recruiter to reach 50 successful admissions',
    data: { recruiter_name: 'Jane Smith', achievement: '50 admissions', referral_code: 'OUK87654' },
    is_read: true,
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString() // 3 days ago
  },
  {
    id: 17,
    admin_id: 1,
    type: 'system_maintenance',
    title: 'Scheduled maintenance completed',
    message: 'Database optimization and security updates applied successfully',
    data: { maintenance_type: 'database_optimization', duration: '2 hours', status: 'completed' },
    is_read: true,
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString() // 1 week ago
  },
  {
    id: 18,
    admin_id: 1,
    type: 'payment_pending',
    title: 'Pending payments require attention',
    message: '8 recruiters have pending commission payments totaling KES 125,000',
    data: { pending_count: 8, total_amount: 125000, oldest_pending: '15 days' },
    is_read: true,
    created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() // 10 days ago
  },
  {
    id: 19,
    admin_id: 1,
    type: 'audit_alert',
    title: 'Unusual login activity detected',
    message: 'Multiple failed login attempts from IP 192.168.1.100 - security review recommended',
    data: { ip_address: '192.168.1.100', attempt_count: 15, time_window: '30 minutes' },
    is_read: true,
    created_at: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString() // 2 weeks ago
  },
  {
    id: 20,
    admin_id: 1,
    type: 'system_update',
    title: 'System update deployed successfully',
    message: 'Version 2.1.0 deployed with enhanced reporting features and bug fixes',
    data: { version: '2.1.0', features: ['enhanced_reporting', 'bug_fixes'], deployment_time: '15 minutes' },
    is_read: true,
    created_at: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString() // 3 weeks ago
  }
];
export const mockPaymentUploads = [
  {
    id: 1,
    uploaded_by: 3,
    filename: 'march_2024_payments.csv',
    total_records: 25,
    successful_records: 23,
    failed_records: 2,
    total_amount: 185000,
    upload_status: 'completed',
    upload_date: '2024-03-15T10:30:00Z',
    processed_at: '2024-03-15T10:35:00Z',
    notes: 'Monthly commission payments for March 2024'
  },
  {
    id: 2,
    uploaded_by: 3,
    filename: 'february_2024_payments.csv',
    total_records: 30,
    successful_records: 30,
    failed_records: 0,
    total_amount: 225000,
    upload_status: 'completed',
    upload_date: '2024-02-28T14:20:00Z',
    processed_at: '2024-02-28T14:25:00Z',
    notes: 'Monthly commission payments for February 2024'
  },
  {
    id: 3,
    uploaded_by: 3,
    filename: 'bonus_payments_q1.csv',
    total_records: 15,
    successful_records: 12,
    failed_records: 3,
    total_amount: 75000,
    upload_status: 'completed',
    upload_date: '2024-03-31T16:45:00Z',
    processed_at: '2024-03-31T16:50:00Z',
    notes: 'Q1 performance bonus payments'
  },
  {
    id: 4,
    uploaded_by: 3,
    filename: 'april_2024_payments.csv',
    total_records: 28,
    successful_records: 0,
    failed_records: 0,
    total_amount: 0,
    upload_status: 'processing',
    upload_date: '2024-04-15T09:15:00Z',
    processed_at: null,
    notes: 'Monthly commission payments for April 2024 - currently processing'
  }
];

export const mockPaymentUploadDetails = [
  // March 2024 successful payments
  {
    id: 1,
    upload_id: 1,
    row_number: 1,
    recruiter_email: 'john@example.com',
    referral_code: 'OUK12345678',
    amount_paid: 8500,
    payment_method: 'M-Pesa',
    payment_reference: 'MP240315001',
    payment_date: '2024-03-15',
    processing_status: 'success',
    error_message: null,
    recruiter_id: 1
  },
  {
    id: 2,
    upload_id: 1,
    row_number: 2,
    recruiter_email: 'jane@example.com',
    referral_code: 'OUK87654321',
    amount_paid: 12000,
    payment_method: 'Bank Transfer',
    payment_reference: 'BT240315002',
    payment_date: '2024-03-15',
    processing_status: 'success',
    error_message: null,
    recruiter_id: 2
  },
  // March 2024 failed payments
  {
    id: 3,
    upload_id: 1,
    row_number: 15,
    recruiter_email: 'invalid@email.com',
    referral_code: 'OUK99999999',
    amount_paid: 5000,
    payment_method: 'M-Pesa',
    payment_reference: 'MP240315015',
    payment_date: '2024-03-15',
    processing_status: 'failed',
    error_message: 'Recruiter not found with email: invalid@email.com',
    recruiter_id: null
  },
  {
    id: 4,
    upload_id: 1,
    row_number: 20,
    recruiter_email: 'peter@example.com',
    referral_code: 'OUK11223344',
    amount_paid: -1500,
    payment_method: 'M-Pesa',
    payment_reference: 'MP240315020',
    payment_date: '2024-03-15',
    processing_status: 'failed',
    error_message: 'Invalid amount: -1500. Amount must be positive.',
    recruiter_id: 3
  }
];

export const mockFinancialStats = {
  totalPaymentsProcessed: 485000,
  totalRecruiterspaid: 68,
  pendingPayments: 125000,
  averagePaymentAmount: 7132,
  monthlyPayments: [
    { month: 'Jan', amount: 165000, count: 22 },
    { month: 'Feb', amount: 225000, count: 30 },
    { month: 'Mar', amount: 185000, count: 25 },
    { month: 'Apr', amount: 95000, count: 12 }
  ],
  paymentMethods: [
    { method: 'M-Pesa', count: 45, percentage: 65.2 },
    { method: 'Bank Transfer', count: 20, percentage: 29.0 },
    { method: 'Cash', count: 3, percentage: 4.3 },
    { method: 'Cheque', count: 1, percentage: 1.4 }
  ]
};
export const mockRecruiterPayments = [
  {
    recruiter_id: 1,
    recruiter_name: 'John Doe',
    recruiter_email: 'john@example.com',
    referral_code: 'OUK12345678',
    total_commissions_earned: 45000,
    total_paid: 37500,
    pending_amount: 7500,
    last_payment_date: '2024-03-15',
    payment_count: 8,
    admissions_count: 25,
    enrollments_count: 15,
    payment_history: [
      {
        id: 1,
        amount: 8500,
        payment_date: '2024-03-15',
        payment_method: 'M-Pesa',
        reference: 'MP240315001',
        status: 'completed',
        upload_id: 1
      },
      {
        id: 2,
        amount: 12000,
        payment_date: '2024-02-28',
        payment_method: 'Bank Transfer',
        reference: 'BT240228001',
        status: 'completed',
        upload_id: 2
      },
      {
        id: 3,
        amount: 9500,
        payment_date: '2024-01-31',
        payment_method: 'M-Pesa',
        reference: 'MP240131001',
        status: 'completed',
        upload_id: 3
      },
      {
        id: 4,
        amount: 7500,
        payment_date: null,
        payment_method: null,
        reference: null,
        status: 'pending',
        upload_id: null
      }
    ]
  },
  {
    recruiter_id: 2,
    recruiter_name: 'Jane Smith',
    recruiter_email: 'jane@example.com',
    referral_code: 'OUK87654321',
    total_commissions_earned: 62000,
    total_paid: 55000,
    pending_amount: 7000,
    last_payment_date: '2024-03-15',
    payment_count: 12,
    admissions_count: 35,
    enrollments_count: 28,
    payment_history: [
      {
        id: 5,
        amount: 15000,
        payment_date: '2024-03-15',
        payment_method: 'Bank Transfer',
        reference: 'BT240315002',
        status: 'completed',
        upload_id: 1
      },
      {
        id: 6,
        amount: 18000,
        payment_date: '2024-02-28',
        payment_method: 'Bank Transfer',
        reference: 'BT240228002',
        status: 'completed',
        upload_id: 2
      },
      {
        id: 7,
        amount: 22000,
        payment_date: '2024-01-31',
        payment_method: 'Bank Transfer',
        reference: 'BT240131002',
        status: 'completed',
        upload_id: 3
      },
      {
        id: 8,
        amount: 7000,
        payment_date: null,
        payment_method: null,
        reference: null,
        status: 'pending',
        upload_id: null
      }
    ]
  },
  {
    recruiter_id: 3,
    recruiter_name: 'Peter Kamau',
    recruiter_email: 'peter@example.com',
    referral_code: 'OUK11223344',
    total_commissions_earned: 28500,
    total_paid: 21000,
    pending_amount: 7500,
    last_payment_date: '2024-02-28',
    payment_count: 5,
    admissions_count: 18,
    enrollments_count: 12,
    payment_history: [
      {
        id: 9,
        amount: 6500,
        payment_date: '2024-02-28',
        payment_method: 'M-Pesa',
        reference: 'MP240228003',
        status: 'completed',
        upload_id: 2
      },
      {
        id: 10,
        amount: 8000,
        payment_date: '2024-01-31',
        payment_method: 'M-Pesa',
        reference: 'MP240131003',
        status: 'completed',
        upload_id: 3
      },
      {
        id: 11,
        amount: 6500,
        payment_date: '2023-12-31',
        payment_method: 'M-Pesa',
        reference: 'MP231231003',
        status: 'completed',
        upload_id: 4
      },
      {
        id: 12,
        amount: 7500,
        payment_date: null,
        payment_method: null,
        reference: null,
        status: 'pending',
        upload_id: null
      }
    ]
  },
  {
    recruiter_id: 4,
    recruiter_name: 'Mary Wanjiku',
    recruiter_email: 'mary@example.com',
    referral_code: 'OUK55667788',
    total_commissions_earned: 38000,
    total_paid: 30500,
    pending_amount: 7500,
    last_payment_date: '2024-03-15',
    payment_count: 7,
    admissions_count: 22,
    enrollments_count: 18,
    payment_history: [
      {
        id: 13,
        amount: 9200,
        payment_date: '2024-03-15',
        payment_method: 'Bank Transfer',
        reference: 'BT240315004',
        status: 'completed',
        upload_id: 1
      },
      {
        id: 14,
        amount: 11000,
        payment_date: '2024-02-28',
        payment_method: 'Bank Transfer',
        reference: 'BT240228004',
        status: 'completed',
        upload_id: 2
      },
      {
        id: 15,
        amount: 10300,
        payment_date: '2024-01-31',
        payment_method: 'M-Pesa',
        reference: 'MP240131004',
        status: 'completed',
        upload_id: 3
      },
      {
        id: 16,
        amount: 7500,
        payment_date: null,
        payment_method: null,
        reference: null,
        status: 'pending',
        upload_id: null
      }
    ]
  },
  {
    recruiter_id: 5,
    recruiter_name: 'David Ochieng',
    recruiter_email: 'david@example.com',
    referral_code: 'OUK99887766',
    total_commissions_earned: 31500,
    total_paid: 24000,
    pending_amount: 7500,
    last_payment_date: '2024-03-15',
    payment_count: 6,
    admissions_count: 20,
    enrollments_count: 14,
    payment_history: [
      {
        id: 17,
        amount: 7800,
        payment_date: '2024-03-15',
        payment_method: 'M-Pesa',
        reference: 'MP240315005',
        status: 'completed',
        upload_id: 1
      },
      {
        id: 18,
        amount: 8200,
        payment_date: '2024-02-28',
        payment_method: 'M-Pesa',
        reference: 'MP240228005',
        status: 'completed',
        upload_id: 2
      },
      {
        id: 19,
        amount: 8000,
        payment_date: '2024-01-31',
        payment_method: 'Bank Transfer',
        reference: 'BT240131005',
        status: 'completed',
        upload_id: 3
      },
      {
        id: 20,
        amount: 7500,
        payment_date: null,
        payment_method: null,
        reference: null,
        status: 'pending',
        upload_id: null
      }
    ]
  }
];